module.exports = __webpack_public_path__ + "img/cn_pocket-8.f848e6b.jpg";